'use client'

import React, { MouseEventHandler } from 'react'

import { cn } from '@/lib/utils'

import { Button, ButtonVariantType } from './Button.component'
import { Icon } from './Icon.component'
import { IconType } from './Icon.types'

interface ButtonIconProps {
  className?: string
  iconType: IconType
  isDisabled?: boolean
  variant?: ButtonVariantType
  onClick?: MouseEventHandler<HTMLButtonElement>
  ariaLabel?: string
  ref?: React.ForwardedRef<HTMLButtonElement>
}

export const ButtonIcon = ({
  className,
  iconType,
  isDisabled,
  onClick,
  variant,
  ariaLabel,
}: ButtonIconProps) => {
  const isPrimary = variant && variant === 'primary'

  return (
    <Button
      disabled={isDisabled}
      className={className}
      variant={variant ?? 'secondary'}
      size="icon"
      onClick={onClick}
      aria-label={ariaLabel && ariaLabel}
    >
      <Icon className={cn(isPrimary && 'icon-light')} type={iconType} />
    </Button>
  )
}
